'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FormElement = require('./FormElement');

var _FormElement2 = _interopRequireDefault(_FormElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = this.node.getElementsByTagName('input')[0];
      if (nextProps.defaultChecked !== input.checked) {
        input.checked = nextProps.defaultChecked;
      }
    }
  }, {
    key: 'renderCheckbox',
    value: function renderCheckbox(_ref) {
      var _this2 = this;

      var className = _ref.className,
          label = _ref.label,
          checkboxRef = _ref.checkboxRef,
          props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'label', 'checkboxRef']);

      var checkClassNames = (0, _classnames2.default)(className, 'slds-checkbox');
      return _react2.default.createElement(
        'label',
        {
          ref: function ref(node) {
            _this2.node = node;
            if (checkboxRef) checkboxRef(node);
          },
          className: checkClassNames
        },
        _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, props)),
        _react2.default.createElement('span', { className: 'slds-checkbox--faux' }),
        _react2.default.createElement(
          'span',
          { className: 'slds-form-element__label' },
          label
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          grouped = _props.grouped,
          required = _props.required,
          error = _props.error,
          totalCols = _props.totalCols,
          cols = _props.cols,
          props = (0, _objectWithoutProperties3.default)(_props, ['grouped', 'required', 'error', 'totalCols', 'cols']);

      var formElemProps = { required: required, error: error, totalCols: totalCols, cols: cols };
      return grouped ? this.renderCheckbox(props) : _react2.default.createElement(
        _FormElement2.default,
        (0, _extends3.default)({
          formElementRef: function formElementRef(node) {
            return _this3.node = node;
          }
        }, formElemProps),
        this.renderCheckbox(props)
      );
    }
  }]);
  return Checkbox;
}(_react.Component);

exports.default = Checkbox;


Checkbox.propTypes = {
  className: _react.PropTypes.string,
  label: _react.PropTypes.string,
  required: _react.PropTypes.bool,
  error: _FormElement2.default.propTypes.error,
  totalCols: _react.PropTypes.number,
  cols: _react.PropTypes.number,
  grouped: _react.PropTypes.bool,
  checkboxRef: _react.PropTypes.func,
  name: _react.PropTypes.string,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  checked: _react.PropTypes.bool,
  defaultChecked: _react.PropTypes.bool
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/react-lightning-design-system/lib/scripts/Checkbox.js
// module id = 432
// module chunks = 0